import { Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';


const hostname = 'NexGTv';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  
  { path: 'detail/:name/:code/:type', loadComponent: () => import('./views/details/details.component').then(m => m.DetailsComponent) },

  // Profile routes
  { path: 'manage-profile', loadComponent: () => import('./views/profile/profile.component').then(m => m.ProfileComponent) },
  { path: 'manage-profile/add', loadComponent: () => import('./views/profile/add-profile/add-profile.component').then(m => m.AddProfileComponent) },
  { path: 'manage-profile/edit/:id', loadComponent: () => import('./views/profile/edit-profile/edit-profile.component').then(m => m.EditProfileComponent) },
  { path: 'manage-profile/reset-pin/:id', loadComponent: () => import('./views/profile/reset-pin/reset-pin.component').then(m => m.ResetPinComponent) },
  { path: 'manage-profile/enter-pin/:id', loadComponent: () => import('./views/profile/enter-pin/enter-pin.component').then(m => m.EnterPinComponent) },

  // Account routes
  { path: 'myaccount', loadComponent: () => import('./views/myaccount/myaccount.component').then(m => m.MyaccountComponent), data: { title: `My Account` } },
  { path: 'myaccount/manage', loadComponent: () => import('./views/myaccount/manage/manage.component').then(m => m.ManageComponent), data: { title: `My Account` } },

  // Plans routes
  { path: 'myplans', loadComponent: () => import('./views/myplans/myplans.component').then(m => m.MyplansComponent), data: { title: `My Plans` } },
  { path: 'myplans/plan-detail/:packId', loadComponent: () => import('./views/myplans/plan-details/plan-details.component').then(m => m.PlanDetailsComponent), data: { title: `My Plans` } },
  
  // Other routes
  { path: 'redeem-code', loadComponent: () => import('./views/redeem-code/redeem-code.component').then(m => m.RedeemCodeComponent), data: { title: `Redeem Code` } },
  { path: 'watchlist', loadComponent: () => import('./views/watchlist/watchlist.component').then(m => m.WatchlistComponent), data: { title: `Watchlist` } },
  { path: 'help-center', loadComponent: () => import('./views/help-center/help-center.component').then(m => m.HelpCenterComponent), data: { title: `Help Center` } },
  { path: 'subscribe', loadComponent: () => import('./views/subscribe/subscribe.component').then(m => m.SubscribeComponent), data: { title: `View Plans` } },
  { path: 'viewall', loadComponent: () => import('./views/viewall/viewall.component').then(m => m.ViewallComponent), data: { title: `View All` } },

  // Category routes
  { path: 'subcategory', loadComponent: () => import('./views/sub-category-list/sub-category-list.component').then(m => m.SubCategoryListComponent) },
  { path: 'subsubcategory', loadComponent: () => import('./views/sub-sub-category-list/sub-sub-category-list.component').then(m => m.SubSubCategoryListComponent) },

  // Platform pages
  { 
    path: 'app-pages/:langCode/:platform/:page', 
    loadComponent: () => import('./views/platform-pages/platform-pages.component').then(m => m.PlatformPagesComponent),
    data: { componentName: "PlatformPagesComponent" }
  },

  // Static pages
  { path: 'contactus', loadComponent: () => import('./views/contact-us/contact-us.component').then(m => m.ContactUsComponent), data: { title: 'Contact us' } },
  { path: 'aboutus', loadComponent: () => import('./views/about-us/about-us.component').then(m => m.AboutUsComponent), data: { title: 'About us' } },
  { path: 'policy', loadComponent: () => import('./views/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent), data: { title: 'Privacy Policy' } },
  { path: 'terms', loadComponent: () => import('./views/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent), data: { title: 'Term & Condition' } },
  { path: 'faq', loadComponent: () => import('./views/faq/faq.component').then(m => m.FaqComponent), data: { title: 'FAQs' } },

  // Error pages
  { path: '404', loadComponent: () => import('./views/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent), data: { title: '404' } },
  { path: '500', loadComponent: () => import('./views/server-error/server-error.component').then(m => m.ServerErrorComponent), data: { title: '500' } },
  { path: '**', redirectTo: '404' }
];